import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import { STATUS_DATA_TYPE, getStatusData } from "../../../Constant/StatusData";
import { formatDate, formatRP } from "../../../Utils/externalFunctions";
import { getStatusBadge } from "../../../Utils/otherFunctions";
import DateSortFunction from "../../DataTableComponents/DateSortFunction";

export const DaftarUMKColumns = [
  {
    name: <DataTableTitle text={"Kode UMK"} />,
    selector: (row) => row.kode_umk,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"DPSJ"} />,
    selector: (row) => row.id_unit_kerja,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Diajukan Oleh"} />,
    selector: (row) => row.diajukan_oleh,
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Tanggal Dibuat"} />,
    selector: (row) => formatDate(row.date_created),
    sortable: true,
    sortFunction: DateSortFunction("date_created"),
  },
  {
    name: <DataTableTitle text={"Tanggal Mulai"} />,
    selector: (row) => formatDate(row.tanggal_mulai),
    sortable: true,
    sortFunction: DateSortFunction("tanggal_mulai"),
  },
  {
    name: <DataTableTitle text={"Tanggal Selesai"} />,
    selector: (row) => formatDate(row.tanggal_selesai),
    sortable: true,
    sortFunction: DateSortFunction("tanggal_selesai"),
  },
  {
    name: <DataTableTitle text={"Batas Akhir"} />,
    selector: (row) => formatDate(row.batas_akhir),
    sortable: true,
    sortFunction: DateSortFunction("batas_akhir"),
  },
  {
    name: <DataTableTitle text={"Keterangan"} />,
    selector: (row) => row.keterangan,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Status"} />,
    selector: (row) => {
      const statusData = getStatusData(row.id_status_umk, STATUS_DATA_TYPE.UMK);
      return getStatusBadge(statusData);
    },
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Nilai (Rp.)"} />,
    selector: (row) => formatRP(row.nilai),
    sortable: true,
  },
];

export const DaftarUMOColumns = [
  {
    name: <DataTableTitle text={"Kode UMO"} />,
    selector: (row) => row.kode_umo,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"DPSJ"} />,
    selector: (row) => row.id_unit_kerja,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Diajukan Oleh"} />,
    selector: (row) => row.diajukan_oleh,
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Tanggal Dibuat"} />,
    selector: (row) => formatDate(row.date_created),
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Untuk Tanggal"} />,
    selector: (row) => formatDate(row.untuk_tanggal),
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Batas Akhir"} />,
    selector: (row) => formatDate(row.batas_akhir),
    sortable: true,
  },

  {
    name: <DataTableTitle text={"Keperluan"} />,
    selector: (row) => row.keterangan,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Status"} />,
    selector: (row) => {
      const statusData = getStatusData(row.id_status_umo, STATUS_DATA_TYPE.UMO);
      return getStatusBadge(statusData);
    },
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Nilai (Rp)"} />,
    selector: (row) => parseInt(row.nilai),
    sortable: true,
    format: (row) => formatRP(row.nilai),
  },
];

export const DaftarTransaksiColumns = [
  {
    name: <DataTableTitle text={"Kode Transaksi"} />,
    selector: (row) => row.id_transaksi,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Tanggal Transaksi"} />,
    selector: (row) => formatDate(row.tanggal_transaksi),
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Diajukan Oleh"} />,
    selector: (row) => row.diajukan_oleh,
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Keterangan"} />,
    selector: (row) => row.keterangan,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Dibayar Ke"} />,
    selector: (row) => row.dibayarkan_ke,
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Nilai (Rp)"} />,
    selector: (row) => parseInt(row.nilai_transaksi),
    sortable: true,
    format: (row) => formatRP(row.nilai_transaksi),
  },
  {
    name: <DataTableTitle text={"Jenis Pembayaran"} />,
    selector: (row) => row.kode_jenis_pembayaran,
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Status"} />,
    selector: (row) => {
      const statusData = getStatusData(
        row.id_status_transaksi,
        STATUS_DATA_TYPE.Transaksi
      );
      return getStatusBadge(statusData);
    },
    sortable: true,
  },
];
